import { metaPixel } from "../data/tracking";

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    __metaPixelInitialized?: Record<string, boolean>;
  }
}

// Runs once per page load, outside React, so re-renders and StrictMode can't duplicate it.
export function initMetaPixel() {
  if (typeof window === "undefined" || !metaPixel.enabled) return;
  if (!metaPixel.allowedHosts.includes(window.location.hostname)) return;

  // Guard 1: this pixel ID was already initialized during this page load.
  const registry = (window.__metaPixelInitialized = window.__metaPixelInitialized || {});
  if (registry[metaPixel.id]) return;
  registry[metaPixel.id] = true;

  // Guard 2: base code already present (e.g. pasted manually into index.html) — don't init or send PageView again.
  if (window.fbq) return;

  // Official Meta Pixel base code, adapted to TypeScript. Script is placed in <head>.
  const n = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod(...args);
    } else {
      n.queue.push(args);
    }
  } as Fbq;
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  window.fbq("init", metaPixel.id);
  window.fbq("track", "PageView");

  // <noscript> fallback in <body>, matching the official snippet.
  const noscript = document.createElement("noscript");
  noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${metaPixel.id}&ev=PageView&noscript=1" alt="" />`;
  document.body.appendChild(noscript);
}
